import { isEmpty } from "lodash-es";
import { Button, DeleteIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { Key } from "antd/lib/table/interface";
import { useConfirm } from "melco-shared-logic";
import { useDeleteCoupons } from "../../hooks/coupons/useDeleteCoupons";

type BulkActionDeleteCouponsProps = {
    selectedRowKeys: Key[];
    setSelectedRowKeys: (keys: Key[]) => void;
    refetch?: () => Promise<any>;
};

export const BulkActionDeleteCoupons: React.FC<
    BulkActionDeleteCouponsProps
> = ({ selectedRowKeys, setSelectedRowKeys, refetch }) => {
    const { t } = useTranslation();

    const deleteCoupons = useDeleteCoupons();

    const confirmDelete = useConfirm(
        async () => {
            const successfullyDeletedIds = await deleteCoupons(
                selectedRowKeys.map((key) => key.toString())
            );

            if (refetch) {
                refetch();
            }

            // keep items that were not deleted selected
            setSelectedRowKeys(
                selectedRowKeys.filter(
                    (id) => !successfullyDeletedIds.includes(id.toString())
                )
            );
        },
        {
            translationPrefix: selectedRowKeys.length > 1 ? "coupons.actions.delete_multiple" : "coupons.actions.delete",
            translationOptions: {
                count: selectedRowKeys.length,
            },

        }
    );

    if (isEmpty(selectedRowKeys)) {
        return null;
    }

    return (
        <Button
            key="bulk-download"
            icon={<DeleteIcon />}
            onClick={async () => {
                await confirmDelete();
            }}
        >
            {t("coupons.actions.delete.title")}
        </Button>
    );
};
